import React from 'react';
export function StickyHeader() {
  return <div className="sticky top-0 z-40 flex min-h-[36px] w-full items-center justify-center bg-vault-gold px-4 py-2 text-center" data-id="element-171" data-mp="2zat6uoerv308">
      <p className="text-[11px] font-semibold leading-snug text-midnight-navy sm:text-xs" data-id="element-172" data-mp="1ir7t0e0939s0">
        <span className="sm:hidden" data-id="element-173" data-mp="1ds51lwd7122i">🌎 Available for instant download worldwide</span>
        <span className="hidden sm:inline" data-id="element-174" data-mp="1dq1zidyrnihf">🌎 Available for instant download worldwide · One-Time Payment · Automatic currency conversion at checkout</span>
      </p>
    </div>;
}